<template>
  <div class="wrapper">
    <div class="people-hero">

      <div class="people-hero-left">

        <p class="people-hero-title h0 mt-6 pb-5">
          Your push-ad-free, research assistant!
          <!-- <span v-html="$t('page.whatIsLiffery.new2023.title.0')"></span>-->
        </p>
        <p class="people-hero-text font-body-l pb-5">
          <!-- {{ $t('page.whatIsLiffery.new2023.opener.1') }}-->
          Every day we are met with an overwhelming choice of products and information.
        </p>
        <p class="people-hero-text font-body-l">
          Liffery is your quiet space to capture, consider, collaborate and decide.
          <!-- {{ $t('page.whatIsLiffery.new2023.opener.2') }}-->
        </p>

        <router-link
          v-if="getIsAuthenticated"
          :to="{name: routeNames.ROUTE_DASHBOARD}"
        >
          <b-button type="is-primary" class="lfr-button jumbo1">
            {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
          </b-button>
        </router-link>
        <b-button
          v-else
          type="is-primary"
          class="lfr-button jumbo1"
          @click="loginPrompt"
        >
          {{ $t('dict.signUp') }}
        </b-button>
      </div>

      <div class="people-hero-right">
        <div class="people-hero-image-wrapper">
          <img src="@/assets/landing-pages/forPeople/2023/3d-laptop-phone.png"
               srcset="@/assets/landing-pages/forPeople/2023/3d-laptop-phone.png 1x,
                        @/assets/landing-pages/forPeople/2023/3d-laptop-phone-x2.png 2x"
               alt="Hero image"
               class="people-hero-image">
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">


.people-hero {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  padding: 0 6.875rem 4rem;
  color: $black;
  z-index: 5;
  height: 95vh;

  .people-hero-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-top: -12rem;
    max-width: 26rem;
    pointer-events: none;

    .people-hero-title {
      margin-bottom: 3rem;
      font-size: $fontH1Size !important;
      line-height: 3.25rem !important;
    }

    .people-hero-title-light {
      display: block;
      font-weight: $fontWeightNormal;
    }

    .people-hero-text {
      line-height: 1.412rem;
    }

    .lfr-button {
      margin-top: 3rem;
      pointer-events: auto;
    }
  }

  .people-hero-right {
    display: flex;
    align-items: center;
    pointer-events: none;

    .people-hero-image-wrapper {
      margin-right: -12rem;

      img {
        max-height: 900px;
        margin-top: 0;
        margin-left: 50px;

        @media screen and (max-width: $desktop) {
          margin-top: 0;
          margin-left: 0;
        }

        @media screen and (max-width: $tablet) {
          margin-top: 0;
          margin-left: 0;
        }
      }
    }
  }

  @media screen and (max-width: $desktop) {
    padding: 2.5rem 3.4rem;
  }

  @media screen and (max-width: $tablet) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2.5rem 3.4rem;

    .people-hero-left {
      margin-top: 0;
      margin-bottom: 3rem;
      flex-wrap: wrap;
      justify-items: center;

      .people-hero-title {
        margin-bottom: .5rem;
        font-size: 2.4rem !important;
      }

      .people-hero-text {
        margin-top: .5rem;
      }
    }

    .people-hero-right {
      height: 45vh;
    }
  }
  @media screen and (max-width: $mobile) {
    padding: 2.5rem 1rem;
  }
}

</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import MScrollDown from '@/components/molecules/MScrollDown.vue';
import { AuthenticationStore } from '@/store';
import OArrowDownScroll from '@/components/organisms/landing/sections/OArrowDownScroll.vue';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component({
  components: { OArrowDownScroll, MScrollDown }
})
export default class OForPeopleHeroSection extends Vue {
  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaHero
      }
    });
  }
}
</script>
